<script setup lang="ts">
import {TimelineEntryConfig} from "@/hospital/services/HospitalTimelineService";
import {ActivityHospitalTimelineEntry} from "@/hospital/interfaces/hospital-timeline";
import HospitalTimelineBaseEntry from "./HospitalTimelineBaseEntry.vue";
import {hospitalFileApi} from "@/container";
import BaseButton from "@/core/components/base/BaseButton.vue";
import {ref} from "vue";

interface Props {
    entry: ActivityHospitalTimelineEntry
    config: TimelineEntryConfig
}

const loading = ref<boolean>(false);

defineProps<Props>();

/**
 * Download the file associated with the entry.
 */
const downloadFile = async (fileId: number) => {
    loading.value = true;
    return hospitalFileApi().download({id: fileId})
        .then(response => {
            const url = URL.createObjectURL(response);
            window.open(url);
        })
        .finally(() => {
            loading.value = false;
        });
};
</script>

<template>
  <HospitalTimelineBaseEntry :entry="entry" :config="config">
    <div v-if="entry.entryable.activitable_type === 'hospital-patient-file' && entry.entryable.activitable_id">
      <BaseButton density="compact" :loading="loading" @click="downloadFile(entry.entryable.activitable_id)">
        Voir le document
      </BaseButton>
    </div>
    <template #user-info>
      <p
        v-if="entry.entryable.user?.name"
        class="text-xs text-gray-600"
      >
        par {{ entry.entryable.user?.name }}
      </p>
    </template>
  </HospitalTimelineBaseEntry>
</template>
